import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null
}

const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            return state;
        },
        removeUser: (state, action) => {
            state.user = null;
            return state;
        }
    }

});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice;